(() => {
  'use strict';
  const instances = new Map();
  const $ = (selector, root) => root.querySelector(selector);
  const $$ = (selector, root) => [...root.querySelectorAll(selector)];
  function initGallery(root, on) {
    const slides = $$('[data-zx-slide]', root), thumbs = $$('[data-zx-thumb]', root), gallery = $('[data-zx-gallery]', root);
    if (!slides.length) return;
    let current = 0, startX = 0, startY = 0, swipe = false;
    const show = (index, focus = false) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const chosen = i === current; slide.hidden = !chosen; slide.classList.toggle('is-on', chosen); slide.setAttribute('aria-hidden', String(!chosen)); slide.inert = !chosen;
        slide.querySelectorAll('video').forEach(video => { if (!chosen) video.pause(); });
      });
      thumbs.forEach((thumb, i) => { const chosen = i === current; thumb.classList.toggle('is-on', chosen); thumb.setAttribute('aria-selected', String(chosen)); thumb.tabIndex = chosen ? 0 : -1; });
      const count = $('[data-zx-gallery-count]', root); if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      if (focus) thumbs[current]?.focus();
      root.dispatchEvent(new CustomEvent('zx:media-change', { bubbles: true }));
    };
    thumbs.forEach((thumb, i) => on(thumb, 'click', () => show(i)));
    $$('[data-zx-gallery-prev]', root).forEach(button => on(button, 'click', () => show(current - 1)));
    $$('[data-zx-gallery-next]', root).forEach(button => on(button, 'click', () => show(current + 1)));
    if (gallery) {
      on(gallery, 'keydown', event => {
        if (event.target.closest('model-viewer,[data-zx-deck],input,textarea,select')) return;
        const positions = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: slides.length - 1 };
        if (!(event.key in positions)) return; event.preventDefault(); show(positions[event.key], true);
      });
      on(gallery, 'pointerdown', event => { swipe = !event.target.closest('model-viewer,button,input,video,[data-zx-deck]'); startX = event.clientX; startY = event.clientY; });
      on(gallery, 'pointerup', event => { const dx = event.clientX - startX; if (swipe && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(event.clientY - startY)) show(current + (dx < 0 ? 1 : -1)); swipe = false; });
      on(gallery, 'pointercancel', () => { swipe = false; });
    }
    show(0);
  }


  function init(root) {
    if (instances.has(root)) return;
    const form = root.querySelector('[data-pinball-product-form]');
    if (!form) return;
    if (form.hasAttribute('data-review-configurator')) {
      const abort = new AbortController(); instances.set(root, abort);
      initGallery(root, (el, type, fn) => el.addEventListener(type, fn, { signal: abort.signal }));
      return;
    }
    const options = [...form.querySelectorAll('[data-pinball-variant-option]')];
    const selectedId = () => options.find(option => option.checked)?.value;
    const button = form.querySelector('[data-pinball-submit]');
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-pinball-variants]').textContent); } catch (_) { return; }
    if (!options.length || !button || !Array.isArray(variants)) return;
    const abort = new AbortController();
    instances.set(root, abort);
    const on = (el, type, fn) => el.addEventListener(type, fn, { signal: abort.signal });
    initGallery(root, on);
    const price = root.querySelector('[data-pinball-price]');
    const compare = root.querySelector('[data-pinball-compare]');
    const savings = root.querySelector('[data-pinball-savings]');
    const configurationNote = root.querySelector('[data-pinball-configuration-note]');
    const title = root.querySelector('[data-pinball-variant-title]');
    const sku = root.querySelector('[data-pinball-sku]');
    const payment = form.querySelector('[data-pinball-payment]');
    function update(id, changeUrl) {
      const variant = variants.find(v => String(v.id) === String(id));
      if (!variant) return false;
      options.forEach(option => { option.checked = option.value === String(variant.id); });
      // Money is formatted by Shopify in the active storefront currency.
      if (price) price.innerHTML = variant.price;
      if (compare) { compare.innerHTML = variant.compare; compare.hidden = !variant.onSale; }
      if (savings) { savings.innerHTML = variant.savings || ''; savings.hidden = !variant.onSale; }
      if (configurationNote) configurationNote.textContent = variant.configurationNote || '';
      if (title) title.textContent = variant.title;
      if (sku) { sku.textContent = variant.sku || ''; sku.hidden = !variant.sku; }
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
      if (payment) payment.hidden = !variant.available;
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        try { window.history.replaceState(window.history.state, '', url); } catch (_) { /* file URL history varies by browser; selected state is preserved */ }
      }
      if (variant.mediaId) {
        const slides = [...root.querySelectorAll('[data-zx-slide]')];
        const index = slides.findIndex(slide => slide.dataset.mediaId === String(variant.mediaId));
        if (index >= 0) root.querySelectorAll('[data-zx-thumb]')[index]?.click();
      }
      root.dispatchEvent(new CustomEvent('pinball:variant-change', { bubbles: true, detail: { variant } }));
      return true;
    }
    const externalFrames = [...root.querySelectorAll('[data-zx-gallery] iframe')].map(frame => ({frame, src: frame.getAttribute('src')}));
    const syncExternalMedia = () => externalFrames.forEach(({frame, src}) => {
      const visible = !document.hidden && !frame.closest('[hidden],[inert],[aria-hidden="true"]');
      if (!visible && frame.hasAttribute('src')) frame.removeAttribute('src');
      else if (visible && src && frame.getAttribute('src') !== src) frame.setAttribute('src', src);
    });
    on(root, 'zx:media-change', syncExternalMedia);
    on(document, 'visibilitychange', syncExternalMedia);
    syncExternalMedia();
    options.forEach(option => on(option, 'change', () => { if (option.checked) update(option.value, true); }));
    on(window, 'popstate', () => update(new URL(window.location.href).searchParams.get('variant') || selectedId(), false));
    on(document, 'shopify:section:unload', event => {
      if (event.target === root || event.target.contains(root)) { abort.abort(); instances.delete(root); }
    });
    const requestedVariant = new URL(window.location.href).searchParams.get('variant');
    if (!update(requestedVariant, false)) update(selectedId(), false);
    if (payment && window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
    // Submission remains a normal Shopify product form. It works without JavaScript,
    // carries the selected variant and quantity, and uses Shopify's cart/checkout.
  }
  function boot(scope = document) {
    if (scope.matches?.('[data-pinball-native]')) init(scope);
    scope.querySelectorAll('[data-pinball-native]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

